import styled, { css } from 'styled-components';
import { Button, ButtonProps } from '@lendi-ui/button';
import { mt } from '@lendi-ui/spacing';

interface ActonProps extends ButtonProps {
  customized?: boolean;
}

export const Action = styled(Button)<ActonProps>`
  &:first-child {
    ${mt('nil')}
  }
  ${(props) =>
    props.customized &&
    css`
      text-transform: unset;
      font-size: 16px;
    `}
  ${(props) => (props.customized ? mt('lg') : mt('sm'))}}
`;
